<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="private-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="unlockPrivateOffersEnabled">Private Offers
          <i class="pi pi-info-circle"
             pTooltip="Enable account-level private offers, including Unlock/Reveal experiences across the website."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="unlockPrivateOffersEnabled"
          formControlName="unlockPrivateOffersEnabled">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="includePrivateOffersInExternalAdvertising">Include Private Offers in External Advertising</label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="includePrivateOffersInExternalAdvertising"
          formControlName="includePrivateOffersInExternalAdvertising">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="showPriceComparison">Show Public Offer Comparison
          <i class="pi pi-info-circle"
             pTooltip="When enabled, shoppers will see the public offer displayed with a strikethrough next to their unlocked private offer for comparison."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="showPriceComparison"
          formControlName="showPriceComparison">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="privateOfferTextColor">Private Offer Text Color
          <i class="pi pi-info-circle"
             pTooltip="Configure the color of the private offer text on VDP."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="color-input-control">
          <input id="privateOfferTextColor"
                 type="color"
                 formControlName="privateOfferTextColor"
                 class="color-input-swatch" />
          <input
            type="text"
            class="color-input-hex"
            [value]="form?.get('privateOfferTextColor')?.value"
            (input)="form?.get('privateOfferTextColor')?.setValue($any($event.target).value); form?.get('privateOfferTextColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="privateOfferButtonColor">Private Offer Button Color
          <i class="pi pi-info-circle"
             pTooltip="Configure the color of the Private Offer button on VDP."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="color-input-control">
          <input id="privateOfferButtonColor"
                 type="color"
                 formControlName="privateOfferButtonColor"
                 class="color-input-swatch" />
          <input
            type="text"
            class="color-input-hex"
            [value]="form?.get('privateOfferButtonColor')?.value"
            (input)="form?.get('privateOfferButtonColor')?.setValue($any($event.target).value); form?.get('privateOfferButtonColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <label class="field-input-label tab-input-label label-field">
        Pre-Unlock CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Changes the main call-to-action text on VDP before unlock."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="preUnlockCtaText">
    </div>
    <div class="tab-panel-input-wrapper">
      <label class="field-input-label tab-input-label label-field">
        Post-Unlock CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Changes the main call-to-action text on VDP after unlock."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="postUnlockCtaText">
    </div>
    <div class="tab-panel-input-wrapper">
      <label class="field-input-label tab-input-label label-field">
        Unlock Form Disclaimer Text
        <i class="pi pi-info-circle"
           pTooltip="Configures the disclosure text that appears on the bottom of the “Unlock” disclosure."
           tooltipPosition="top"></i>
      </label>
      <textarea
        pInputText
        rows="6"
        class="tall-textarea"
        formControlName="privateOfferDisclosure"></textarea>
    </div>
    <h3 class="section-heading">Savings Message</h3>
    <div class="savings-message-section">
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="displaySavingsMessage">Display Savings Message
            <i class="pi pi-info-circle"
               pTooltip="Displays the unlocked dollar amount savings message in the VDP Offer Display after a Private Offer is successfully unlocked. Offer recalculations will occur regardless of whether this message is shown."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <p-toggleswitch
            id="displaySavingsMessage"
            formControlName="displaySavingsMessage">
          </p-toggleswitch>
        </div>
      </div>
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="displayUnlockedSellingPrice">Display Unlocked Selling Price
            <i class="pi pi-info-circle"
               pTooltip="Shows the original and unlocked Selling Price after a fixed discount is applied."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <p-toggleswitch
            id="displayUnlockedSellingPrice"
            formControlName="displayUnlockedSellingPrice">
          </p-toggleswitch>
        </div>
      </div>
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="savingsMessage">Savings Message
            <i class="pi pi-info-circle"
               pTooltip="The Savings message appears immediately after the flat dollar amount savings displayed in the VDP Offer Display."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <input id="savingsMessage"
                 type="text"
                 pInputText
                 class="text-input savings-message-input"
                 formControlName="savingsMessage"
                 maxlength="255" />
        </div>
      </div>
      <div class="tab-panel-input-wrapper">
        <div class="field-input-label tab-input-label label-field">
          <label for="savingsMessageBackgroundColor">Savings Message Background Color
            <i class="pi pi-info-circle"
               pTooltip="Controls the background color of the unlocked Savings Message displayed in the VDP Offer Display."
               tooltipPosition="top"></i></label>
        </div>
        <div class="field-switch-label">
          <div class="savings-message-background-color-control">
            <input id="savingsMessageBackgroundColor"
                   type="color"
                   formControlName="savingsMessageBackgroundColor"
                   class="savings-message-background-color-swatch" />
            <input
              type="text"
              class="savings-message-background-color-hex"
              [value]="form?.get('savingsMessageBackgroundColor')?.value"
              (input)="form?.get('savingsMessageBackgroundColor')?.setValue($any($event.target).value); form?.get('savingsMessageBackgroundColor')?.markAsDirty()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
